import { render, staticRenderFns } from "./eROT.vue?vue&type=template&id=0e35dd74&scoped=true&"
import script from "./eROT.vue?vue&type=script&lang=js&"
export * from "./eROT.vue?vue&type=script&lang=js&"
import style0 from "./eROT.vue?vue&type=style&index=0&id=0e35dd74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e35dd74",
  null
  
)

export default component.exports